import { render, staticRenderFns } from "./questionnaireVote.vue?vue&type=template&id=28790536"
import script from "./questionnaireVote.vue?vue&type=script&lang=js"
export * from "./questionnaireVote.vue?vue&type=script&lang=js"
import style0 from "./questionnaireVote.vue?vue&type=style&index=0&id=28790536&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports